import request from '@/plugins/request'
export const list46Item = (pageSize,pageNum,data) => {
  return request({
    url: `/afterSale/46Item/list/${pageSize}/${pageNum}`,
    method: 'POST',
    data
  })
}
export const listInfo = (id) => {
  return request({
    url: `/afterSale/46Item/info/${id}`,
    method: 'POST',
  })
}
export const listContentInfo = (id) => {
  return request({
    url: `/afterSale/46Item/contentInfo/${id}`,
    method: 'GET',
  })
}
export const listMenu = () => {
  return request({
    url: `/afterSale/46Item/getMenu`,
    method: 'GET',
  })
}
export const ChangeCheck = (data) => {
  return request({
    url: `/afterSale/46Item/check`,
    method: 'POST',
    data
  })
}
